<main id="main">
    <!-- ======= Breadcrumbs ======= -->
    <div class="breadcrumbs" data-aos="fade-in">
        <div class="container">
            <h2 [innerHTML]="title"></h2>
        </div>
    </div><!-- End Breadcrumbs -->

    <section id="testimonials1">
        <div class="container" data-aos="fade-up">

            <!-- <div class="section-title pb-0">
                <h2>Read Online</h2>
                <p class="marathi-font" [innerHTML]="title"></p><br>
            </div> -->

            <!-- <div class="row" id="gallery">
                <div class="column" *ngFor="let image of gallery | async ; let i = index" >
                <img class="col-lg-3 col-md-6 col-sm-12 col-xs-12" src="{{'../assets/'+image.path}}" >
            </div> -->


           <app-imagegrid [gallery_col1]="gallery_col1" 
           [gallery_col2]="gallery_col2"
           [gallery_col3]="gallery_col3"
           [gallery_col4]="gallery_col4"></app-imagegrid>
        </div>
    </section>
</main>